import React from 'react';
import io from 'socket.io-client';

// javascript object to store the socket
export const socket = {
    socket: null,
    // function to connect to the socket
    connect: function (id, liveToken = null) {
        // Use provided token or fall back to TokenService for backward compatibility
        if (!liveToken) {
            console.log(liveToken)
            console.warn("No live token provided, cancelling socket connection.");
            return;
        }
        
        this.socket = io.connect(
            process.env.REACT_APP_WEBSOCKET_URI,
            {
                extraHeaders: {
                    "X-Auth-LiveToken": liveToken,
                    "X-Sock-Id": id
                }
            });
    },
    // function to disconnect from the socket
    disconnect: function () {
        this.socket.disconnect();
    },
    // function to get the socket
    getSocket: function () {
        return this.socket;
    }
}

export const SocketContext = React.createContext();